export { default } from './PageOrdersBooking.vue'
